module.exports = __webpack_public_path__ + "img/input-minus.51562bdd.svg";